module.exports = __webpack_public_path__ + "img/cross.fecbc9df.svg";